import { RefreshCw, X } from 'lucide-react'
import * as React from 'react'
import { useAppUpdateAvailable } from '@/hooks/useAppUpdateAvailable'
import { Button } from '@/components/ui/button'

/**
 * Quiet Notion-style callout at the top of the app when a newer deploy is live
 * than the JS this tab is running. Primary action reloads; dismiss hides until
 * the next full page load (tab session only).
 */
export function UpdateAvailableBanner() {
  const updateAvailable = useAppUpdateAvailable()
  const [dismissed, setDismissed] = React.useState(false)

  if (!updateAvailable || dismissed) {
    return null
  }

  return (
    <div
      role="status"
      className="sticky top-0 z-50 flex flex-wrap items-center justify-between gap-3 border-b border-line bg-accent-soft px-4 py-2 text-sm text-accent-ink"
    >
      <div className="flex min-w-0 items-center gap-2">
        <RefreshCw className="h-4 w-4 shrink-0 opacity-80" aria-hidden />
        <p className="min-w-0">
          <span className="font-medium">A new version is available.</span>
          {' '}
          Refresh to get the latest updates.
        </p>
      </div>
      <div className="flex items-center gap-1.5">
        <Button
          type="button"
          size="sm"
          onClick={() => {
            window.location.reload()
          }}
        >
          <RefreshCw className="h-3.5 w-3.5" />
          Refresh
        </Button>
        <Button
          type="button"
          size="sm"
          variant="ghost"
          aria-label="Dismiss update notice"
          className="text-inherit hover:bg-black/5 dark:hover:bg-white/10"
          onClick={() => setDismissed(true)}
        >
          <X className="h-4 w-4" />
        </Button>
      </div>
    </div>
  )
}
